<template>
  <div>

    <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>Estat SCE</span>
          </div>
          <div class="card-block">
            <canvas id="status-home-analyzer" style="height: 300px; width: 100%;"></canvas>
          </div>
          <div class="card-footer" style="margin-top: -10px">
            <ul>
              <li>
                <div class="text-muted">{{ web_texts.partials.status }}</div>
                <strong>{{ status_analyzer }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{ web_texts.partials.current_active_power_combined }}</span>
          </div>
          <div class="card-block">
            <!--            <canvas id="active-power-general" style="height: 295px; width: 100%;"></canvas>-->
            <div id="active-power-general" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{ web_texts.partials.current_active_power_combined }}</div>
                <strong>{{ api_general }} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <span>{{ web_texts.partials.historical_active_energy }}</span>
          </div>
          <div class="card-block">
            <table class="table">
              <thead style="background-color: #576bff">
              <tr>
                <th scope="col" class="col-md-2" style="text-align: center;">Dispositiu</th>
                <th scope="col" style="text-align: center;">Lectura</th>
                <th scope="col" class="col-md-2" style="text-align: center;">Dispositiu</th>
                <th scope="col" style="text-align: center;">Lectura</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td style="background-color: #a9b3ff">{{table_energy[0][0]}}</td>
                <td style="text-align: center">{{table_energy[0][1]}}kWh</td>
                <td style="background-color: #a9b3ff">{{table_energy[1][0]}}</td>
                <td style="text-align: center">{{table_energy[1][1]}}kWh</td>
              </tr>
              <tr>
                <td style="background-color: #a9b3ff">{{table_energy[2][0]}}</td>
                <td style="text-align: center">{{table_energy[2][1]}}kWh</td>
                <td style="background-color: #a9b3ff">{{table_energy[3][0]}}</td>
                <td style="text-align: center">{{table_energy[3][1]}}kWh</td>
              </tr>
              <tr>
                <td style="background-color: #a9b3ff">{{table_energy[4][0]}}</td>
                <td style="text-align: center">{{table_energy[4][1]}}kWh</td>
                <td style="background-color: #a9b3ff">{{table_energy[5][0]}}</td>
                <td style="text-align: center">{{table_energy[5][1]}}kWh</td>
              </tr>
              <tr>
                <td style="background-color: #a9b3ff">{{table_energy[6][0]}}</td>
                <td style="text-align: center">{{table_energy[6][1]}}kWh</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer" style="margin-top: 48px">
            <ul>
              <li>
                <div class="text-muted">{{ web_texts.partials.total_energy}}</div>
                <strong>{{Math.round(table_energy[0][1]+table_energy[1][1]+table_energy[2][1]+table_energy[3][1]+table_energy[4][1]+table_energy[5][1]+table_energy[6][1]* 100) / 100}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import trans_cat from '../../../translates/cat/Home';
import trans_es from '../../../translates/es/Home';
import constants from '../../../constants';
import middleware from '../../../utilities/middlewares';
import dateRanges from '../../../utilities/dates_intervals';
import dataTransforms from '../../../utilities/data_transformers';

export default {
  name: '',
  props: ['devices', 'master_dev'],
  data() {
    return {
      web_texts: {
        "electric_params": "Paràmetres Elèctrics",
        "generator": "Grup Electrogen",
        "pump_well": "Bomba-Bassa",
        "partials": {
          "historical_active_power_diary": "Històric diari potència activa",
          "historical_active_energy": "Finals de comptadors d'energia",
          "total_energy": "Energia Activa Total Combinada",
          "cos_phi_2": "Cosinus de phi φ",
          "pot_contracted": "Pot. Contractada",
          "pot_penalty": "Pot. Penalització",
          "current_power": "Pot. Actual",
          "status": "Estat",
          "current_active_power": "Potència Activa Instantània Combinada",
          "current_active_power_combined": "Potència Activa Instantània Combinada",
          "cos_phi": "Cosinus de Phi Instantani",
          "monthly_energy_consumed": "Històric anual d'energia consumida",
          "generator_status": "Estat Grup",
          "api_general": "Pot. General",
          "api_generator": "Pot. Grup",
          "current_tension": "Tensió actual",
          "active_power": "Potència activa",
          "active_power_now": "Potència Activa Instantània Combinada",
          "active_reactive_energy": "Energia activa reactiva",
          "Cos_phi": "Cosinus de phi",
          "monthly_active_power": "Històric potencia activa mensual",
          "pump_status": "Estat Bomba",
          "flow_pump": "Cabal Bomba",
          "counter_lecture": "Lec. Comptador",
          "vol_raft": "Niv. Bassa",
          "historical_pump_activations": "Històric activacions bomba",
          "historical_low_level": "Històric nivell bassa"
        }
      },
      period: 'S/D',
      general: '',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi_general: 'S/D',
      api_general: 'S/D',
      ae_general: 'S/D',
      ie_general: 'S/D',
      mdapi_general: 'S/D',
      system_coordinates: '',
      status_analyzer: 'S/D',
      status_show_server: 'S/D',
      status_show_eds: 'S/D',
      status_show_analyzer: 'S/D',
      table_energy: [["Oficines", 0], ["Taller", 0], ["Sala Pintures", 0], ["Sala Descans", 0], ["Laboratori", 0], ["Quadre General", 0], ["Recepcio", 0]]
    }
  },
  created() {
    console.log("Created Energy");
    middleware.userIsLoged();
    window.localStorage.setItem('real_time_control', '["home","energy"]');
    this.web_texts = middleware.selectTranslation(trans_cat, trans_es);

    var out = this;
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.system_coordinates = this.system.coordinates;
    this.current_datetime = dateRanges.getCurrentDateTime();

    var general_interval = setInterval(function () {
      console.log("Interval Energy");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));

      if (contr_rt[1] !== "energy") {
        console.log("Clear energy loop");
        clearInterval(general_interval);
      } else {
        out.current_datetime = dateRanges.getCurrentDateTime();
        out.getRealTimeValues();
      }
    }, 5000);

  },
  mounted() {
    // this.getRealTimeValues(this.getGeneralDevice());
    // this.printStatusChart("rgb(145,145,145)");
    // this.getDiaryActivePowerAnalyzer();
    // this.getYearlyActivePowerAnalyzer();
    this.getRealTimeValues()
    this.getYearlyActivePowerAnalyzer()
  },
  methods: {
    getRealTimeValues() {
      axios.post(constants.ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: JSON.stringify([
          [42, "STATUS", "API", "AE", "IE"],
          [43, "STATUS", "API", "AE", "IE"],
          [44, "STATUS", "API", "AE", "IE"],
          [45, "STATUS", "API", "AE", "IE"],
          [46, "STATUS", "API", "AE", "IE"],
          [47, "STATUS", "API", "AE", "IE"],
          [48, "STATUS", "API", "AE", "IE"]])
      }).then((response) => {

        this.api_general = Math.round((
          parseFloat(response.data[1].value) +
          parseFloat(response.data[5].value) +
          parseFloat(response.data[9].value) +
          parseFloat(response.data[13].value) +
          parseFloat(response.data[17].value) +
          parseFloat(response.data[21].value) +
          parseFloat(response.data[25].value)) * 10) / 10;

        this.table_energy[0][1]=Math.round(parseFloat(response.data[2].value)* 100) / 100;
        this.table_energy[1][1]=Math.round(parseFloat(response.data[6].value)* 100) / 100;
        this.table_energy[2][1]=Math.round(parseFloat(response.data[10].value)* 100) / 100;
        this.table_energy[3][1]=Math.round(parseFloat(response.data[14].value)* 100) / 100;
        this.table_energy[4][1]=Math.round(parseFloat(response.data[18].value)* 100) / 100;
        this.table_energy[5][1]=Math.round(parseFloat(response.data[22].value)* 100) / 100;
        this.table_energy[6][1]=Math.round(parseFloat(response.data[26].value)* 100) / 100;

        this.printPowerGraph();
        if (response.data[24].value === '-') {
          this.status_analyzer = 'S/D';
          this.printStatusChart("rgb(145,145,145)");
        } else {
          this.status_analyzer = 'OK';
          this.printStatusChart("rgb(0,255,0)");
        }
      }, (response) => {
        this.status_analyzer = 'ERROR';
        this.printStatusChart("rgb(255,0,0)");
        console.log(response);
      });
    },
    getDiaryActivePowerAnalyzer() {
      axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: JSON.stringify([[this.general.id, "API"]]),
        client_device: 'd',
        date_range: dateRanges.currentDayDaterange()
      }).then((response) => {
        this.printActivePowerAnalyzer(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, (response) => {
        console.log(response.data);
      });
    },
    getYearlyActivePowerAnalyzer() {
      axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: JSON.stringify([[42, "AEE"]]),
        client_device: 'd',
        date_range: dateRanges.currentYearDaterange()
      }).then((response) => {
        this.printYearEnergyAnalyzer(dataTransforms.dataTransYearlyFormCanvasJS(response.data, "column", ["P. Activa"]));
      }, (response) => {
        console.log(response.data);
      });
    },
    printStatusChart(color) {
      try {
        var opts = {
          angle: -0.50, // The span of the gauge arc
          lineWidth: 0.2, // The line thickness
          radiusScale: 0.80, // Relative radius
          pointer: {
            length: 0, // // Relative to gauge radius
            strokeWidth: 0 // The thickness
          },
          limitMax: false,     // If false, max value increases automatically if value > maxValue
          limitMin: false,     // If true, the min value of the gauge will be fixed
          strokeColor: '#E0E0E0',  // to see which ones work best for you
          generateGradient: true,
          highDpiSupport: true,     // High resolution support
          staticZones: [
            {strokeStyle: color, min: 0, max: 100, height: 1}
          ]
        };
        var target = document.getElementById('status-home-analyzer'); // your canvas element
        var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        gauge.maxValue = 100; // set max gauge value
        gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
        gauge.animationSpeed = 25; // set animation speed (32 is default value)
        gauge.set(100); // set actual value
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph() {
      var myConfig8 = {
        "type": "gauge",
        "scale-r": {
          "aperture": 280,
          "values": "0:72",
          "center": {
            "size": 5,
            "background-color": "#ffff",
            "border-color": "none"
          },
          "ring": {
            "size": 10,
          },
          // "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],  //Scale Labels
          "item": {  //Scale Label Styling
            "font-color": "black",
            "font-family": "Arial",
            "font-size": 12,
            "font-weight": "bold",   //or "normal"
            "font-style": "normal",   //or "italic"
            "offset-r": 0,
            "angle": "auto"
          }
        },
        "plot": {
          "csize": "5%",
          "size": "100%",
          "background-color": "#ffff"
        },
        "series": [
          {"values": [1.016]}
        ]
      };

      myConfig8.series[0].values[0] = this.api_general;

      zingchart.render({
        id: 'active-power-general',
        data: myConfig8,
        height: "100%",
        width: "100%"
      });
    },
    printActivePowerAnalyzer(data) {
      try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data  // random data
        };

        $("#active-power-general-diari").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [ //Scale Markers
              { //Area Marker 1
                "type": "area",
                "range": [0, 0.91],
                "offset-start": 0,
                "offset-end": 0,
                "background-color": "#DF0000",
                "alpha": 0.7
              },
              { //Area Marker 2
                "type": "area",
                "range": [0.91, 1.09],
                "offset-start": 0,
                "offset-end": 0,
                "background-color": "#00ff00",
                "alpha": 0.7
              },
              { //Area Marker 3
                "type": "area",
                "range": [1.09, 2],
                "offset-start": 0,
                "offset-end": 0,
                "background-color": "#d4ff00",
                "alpha": 0.7
              }
            ],
            "ring": {
              "size": 10,
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],  //Scale Labels
            "item": {  //Scale Label Styling
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",   //or "normal"
              "font-style": "normal",   //or "italic"
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [
            {"values": [1.016]}
          ]
        };

        var graph_value = 1;
        if (this.cosi_general <= 1 && this.cosi_general > 0) {
          graph_value = ((5 / 3) * (this.cosi_general - 0.4));
        } else {
          graph_value = ((5 / 3) * (this.cosi_general + 1)) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-general',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch')
      }
    },
    printYearEnergyAnalyzer(data) {
      try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "MM/YYYY"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data  // random data
        };

        $("#ener-act-hom-analyzer").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*Vue map container width*/
#map {
  height: 300px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// EnergyCounters.vue?1f0c50f5